
import React from 'react';
import { ArrowRight } from 'lucide-react';

const GlobalHeader = () => {
  return (
    <div className="w-full bg-[#8B4513] text-white">
      {/* Skip to content link */}
      <div className="sr-only focus-within:not-sr-only">
        <a href="#main-content" className="absolute z-50 p-2 bg-white text-primary focus:block">
          Skip to main content
        </a>
      </div>
      
      {/* Announcement banner - displayed only once */}
      <div className="container mx-auto py-2.5 px-4 flex flex-col sm:flex-row justify-center items-center text-center">
        <span className="mr-2 text-sm sm:text-base">We're back! Click the link to book your tour for the summer 2025 season!</span>
        <a 
          href="/tours" 
          className="flex items-center font-medium hover:text-white/90 transition-colors group whitespace-nowrap"
        >
          <span className="underline underline-offset-2">Select your tour today</span>
          <ArrowRight size={16} className="ml-1 group-hover:translate-x-1 transition-transform"/>
        </a>
      </div>
    </div>
  );
};

export default GlobalHeader;
